import { takeEvery, call, put } from 'redux-saga/effects'
import { CREATE_ROLE, loading, loadRoles } from '../../store/Roles/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(CREATE_ROLE, worker)
}

function* worker({ payload }) {
    yield put(loading(true))
    try {
        const subuser = yield call(createSubuser, { ...payload })
        if (subuser.error && subuser.error.length) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${CREATE_ROLE}.`, subuser],
                text: "При создании пользователя произошла ошибка. Попробуйте перезагрузить страницу."
            }))
            // yield put(putSubusers([]))
        } else {
            yield put(loadRoles())
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${CREATE_ROLE}.`, e],
            text: "При создании пользователя произошла ошибка." + e.message
        }))
        // yield put(putSubusers([]))
    }
    finally {
        yield put(loading(false))
    }
}

function createSubuser(userdata) {
    let formData = new FormData()

    if (userdata.tags && Array.isArray(userdata.tags))
        userdata.tags = userdata.tags?.filter?.(tag => !!tag) || [];
    
    if (!!!userdata.tags.length)
        userdata.tags = 'NULL'

    Object.keys(userdata).forEach(name => {
        if (Array.isArray(userdata[name])) {
            userdata[name].forEach(tag => {
                formData.append(name + '[]', tag); // Ключевое отличие: tags[]
            });
        } else {

            formData.append(name, userdata[name]);
        }
    });



    return axios({
        url: "/account/roles/insert",
        method: "POST",
        data: formData
    })
        .then(response => response.data)
}
